export default __webpack_public_path__ + "static/media/NL.78358be8.svg";